import { effect, EnvironmentInjector, inject, runInInjectionContext, signal } from "@angular/core";
import { onNewGdtFile } from "../../pages/forms/create-patient/create-patient.component";
import { gdtSettingValue, parseGDTToJSON } from "../../shared-types/configID/gdt";
import { SettingID, KeyValueSettings, IDocSettingBaseNoError, IDocSetting } from "../../shared-types/userconfigTypes";
import { doesDirectoryExist, readAndDeleteFirstFile, saveSetting } from "../../utils/electronHelpers";
import { ApiService } from "../../services/api/api.service";
import { NbGlobalPhysicalPosition } from "@nebular/theme";



export class Setting {
  s: IDocSetting<SettingID>;
  private oldSetting_: any; // used only for comparing if values changed. maybe find another solution.
  private effectRef

  debugRandom;
  environmentInjector = inject(EnvironmentInjector);
  routines: any[] = [];

  constructor(init: IDocSetting<SettingID>, debugCounter: number) {
    this.s = init; // the data that is just passed into, and not calculated.

    this.debugRandom = debugCounter;

   /*  let logger = setInterval(() => {
        console.log("Es loggt: ", this.debugRandom);
    }, 3000);
    this.routines.push(logger); */

    // when dir is updated
    this.effectRef = effect((onCleanup) => {
        onCleanup(() => {
            this.routines.forEach((routine) => { clearInterval(routine) }); 
        });

      this.currentDirectory_();
      let success = this.sanityCheckOnce();
      if (success) {
          this.s.settingIDvalue.dir = this.currentDirectory_();

         // call save here
        this.saveSettingIfChanged();

       /*  this.updateCurrentDirInSetting(
          this.currentDirectory_(),
          init.settingID
        ); */
      }
    }, /* { manualCleanup: true } as CreateEffectOptions */);

    // set directory manually, because this.s cannot be found by the appropriate funtion for some reason.
    this.currentDirectory_.set(this.getCurrentDirBySettingID(init.settingID));
    this.active = true

    // if there is a routine to be ran, run it.
    if ("routine" in this.s.settingIDconfig && this.s.settingIDconfig.routine) {
      this.s.settingIDconfig.routine({ setting: this });
    }

    this.sanityCheckOnce();
    this.sanityCheckRepeated(2000);

    /*   setInterval(() => {
        console.log('settings class : ', this.s); 
      }, 2000); */


      // or comparisons etc.
      this.oldSetting_ =  {
        dir: this.currentDirectory_(),
        enabled: this.s.settingIDvalue.enabled,
        requireRead: this.s.settingIDvalue.requireRead,
        requireWrite: this.s.settingIDvalue.requireWrite,
    }
  }

  // defined by constructor
  public currentDirectory_ = signal("");

  // calculated
  public active = false;
  public sanityCheckPassed = false;

  public onChangeToggleFn = (active: boolean) => {
    console.devlog("onEnabledTriggerFn", active);
    this.s.settingIDvalue.enabled = active;
    this.saveSettingIfChanged();
    return active;
  };

  async sanityCheckOnce() {
    console.devlog("sanityCheckOnce");
    let success = await this.checkDirectory();
    this.handleSanityCheckResult(success, "once");
    return success;
  }

  /*  sanityCheckFailed() {
      this.s.settingIDvalue.enabled = false;
    } */

  sanityCheckRepeated(interval) {
    let repeat = setInterval(async () => {
    //   console.log("sanityCheckRepeated: ", this.s.fullSettingKey);
      this.s.fullSettingKey;
      let success = await this.checkDirectory();
      this.handleSanityCheckResult(success, 'repeated');
    }, interval);

    this.routines.push(repeat);
  }

  handleSanityCheckResult(success: boolean, interval: 'once' | 'repeated') {
    if (!success) {
      this.sanityCheckPassed = false;
      this.active = false;
      this.s.settingIDvalue.enabled = false;
      this.saveSettingIfChanged();
    } else {
      this.sanityCheckPassed = true;
      this.active = true;
      this.saveSettingIfChanged();
    }
  }

  async checkDirectory(): Promise<boolean> {
    let dirOk = await doesDirectoryExist(this.currentDirectory_(), true, true);
    return dirOk;
  }

  getCurrentDirBySettingID(settingID: SettingID) {
    if (settingID === "gdtOutputFolder" || settingID === "gdtInputFolder") {
      return this.s.settingIDvalue.dir;
    }
  }

  updateCurrentDirInSetting(value: string, settingID: SettingID) {
   
  }

  // TODO: Call onSave member function ! for now, do it like this.
  async saveSettingIfChanged() {


    if (JSON.stringify(this.oldSetting_) === JSON.stringify(this.s.settingIDvalue)) {
      //console.log('no change in setting');
      return;
    }


    if (["gdtOutputFolder", "gdtInputFolder"].includes(this.s.settingID)) {

        let fullSetting : gdtSettingValue = {
            dir: this.currentDirectory_(),
            enabled: this.s.settingIDvalue.enabled,
            requireRead: this.s.settingIDvalue.requireRead,
            requireWrite: this.s.settingIDvalue.requireWrite,
        }

        saveSetting(this.s.fullSettingKey, fullSetting);

        // make new setting the old one.
        this.oldSetting_ = this.s.settingIDvalue

    } else {
      throw new Error(
        `No logic in place to save a setting of the setting ID ${this.s.settingID}`
      );
    }

  }

   dispose() { 


    this.s.settingIDconfig

    if('routine' in this.s.settingIDconfig && this.s.settingIDconfig.routine) {
        let type = typeof(this.s.settingIDconfig.routine)
        this.routines

        this.routines.forEach((routine) => { clearInterval(routine) });     

        this.routines = [];


    }

    if (this.effectRef.destroy) {
        this.effectRef.destroy()
        // console.log('Effect disposed');
      }

   }
}
  

// ATTENTION !
// this is to be called by the state service, so it can extract necessary information for the setting and set it into state.
// should make async, as we might be fetching API calls here one day.

export const parametriseSetting = (fullSettingKey: keyof KeyValueSettings, settingValue: KeyValueSettings[keyof KeyValueSettings] ) : IDocSetting<SettingID>=> {


    let settingID = fullSettingKey.split('_')[2] as SettingID;
    
    let theReturn: IDocSetting<SettingID> = {
      fullSettingKey: fullSettingKey,
      isError: false,
      ...getSettingParametersBySettingID(settingID),
      settingID: settingID,
      ...getSettingIDvalue<SettingID>(settingID, settingValue),
      ...getSettingIDConfig<'gdtOutputFolder'>(settingID, settingValue),
    }
    
    return theReturn;
    }

export const getSettingIDvalue = <ConfigID>(settingID: SettingID, settingValue: KeyValueSettings[keyof KeyValueSettings]) : Pick<IDocSettingBaseNoError<SettingID>, 'settingIDvalue'> => {
    switch(settingID){
      case "gdtOutputFolder":
        return { settingIDvalue: {
          dir: (settingValue as gdtSettingValue).dir,
          enabled: (settingValue as gdtSettingValue).enabled,
          requireRead: (settingValue as gdtSettingValue).requireRead,
          requireWrite: (settingValue as gdtSettingValue).requireWrite,
          }
        }
  
      case "gdtInputFolder":
        return { settingIDvalue: {
          dir: (settingValue as gdtSettingValue).dir,
          enabled: (settingValue as gdtSettingValue).enabled,
          requireRead: (settingValue as gdtSettingValue).requireRead,
          requireWrite: (settingValue as gdtSettingValue).requireWrite,
        }
      }  
    }
  }
  
  // TODO: adjust this to take docTypes as parameter and fetch the correct "routine" function programatically !
  // TODO: inject notifications into the routine functions ! 

  export const getSettingIDConfig = <ConfigID extends SettingID>(settingID: SettingID, settingValue: KeyValueSettings[keyof KeyValueSettings]) : Pick<IDocSettingBaseNoError<SettingID>, "settingIDconfig"> => {
  
    switch (settingID) {
      case "gdtOutputFolder":
        let res: Pick<IDocSettingBaseNoError<"gdtOutputFolder">, 'settingIDconfig'> = {
          settingIDconfig: {
            UIcomponent: 'folderPathSelector',
            placeholder: "test", // typescript having issues if the type object is empty.
            onSave: async (setting: gdtSettingValue) => {
              console.devlog('onSave', setting);
              return setting;
          }
        }};
        return res;
    
  
      case "gdtInputFolder":
        let ret: Pick<IDocSettingBaseNoError<"gdtInputFolder">, "settingIDconfig"> = {
          settingIDconfig: {
            UIcomponent: 'folderPathSelector',
            onNewDocument: onNewGdtFile,
            routine: ({setting}) => { // 'that' types the "this" object inside the Setting class.
              let that = setting as Setting;
            //   setInterval(async () => {
            let theInterval = setInterval(async function()  {
              
                  if(that.currentDirectory_() !== "" && that.s.settingIDvalue.enabled) {
                      let fileContent : string = await readAndDeleteFirstFile(that.currentDirectory_()) as string;
                      console.devlog(`routine: trying to read and delete one file from : ${that.currentDirectory_() } : ${fileContent})`);
                        if(fileContent) {
                            
                            try{
                                let parsedGDT = parseGDTToJSON(fileContent);
                                console.devlog('parsedGDT:', parsedGDT);
                                // generate missing data: validUntil, role, twoFA
                                parsedGDT.validuntil = "2030-12-21"
                                parsedGDT.role = 1;
                                parsedGDT.password = "BaSiCpAsSwOrD1337";
                                parsedGDT.twoFA = {}
                                parsedGDT.twoFA.twoFAmethod = "email";
                                
                                console.devlog('parsedGDT extended:', parsedGDT);

                                try{
                                    var success;
                                    runInInjectionContext(that.environmentInjector, async () => {

                                        let apiService = inject(ApiService);
                                        let foo: NbGlobalPhysicalPosition
                                        let physicalPositions = NbGlobalPhysicalPosition;
                                        /* success = await inject(ApiService).createNewUser(parsedGDT) */
                                        success = apiService.createNewUser(parsedGDT)
                                        console.devlog('create user success:', success);
                                        /* inject(ApiService).toastrService.show('success') */
                                        apiService.toastrService.show('success', { status: 'success', position: physicalPositions.BOTTOM_RIGHT });
                                    });
                                } catch(err) {
                                    console.deverror('create user error:', err);
                                }
                                
                            } catch(err) {
                                console.deverror('routine error:', err);
                            }
                        }
                            
                    }
                    }, 2000);

             that.routines.push(theInterval);
             return theInterval;

            },
            onSave: async (setting: gdtSettingValue) => {
                console.devlog('onSave', setting);
                return setting;
            }
          },
        };
  
        return ret;
    }
  }
  
  export const getSettingParametersBySettingID = (settingID: SettingID) : Omit<IDocSetting<SettingID>, 'settingID' | 'settingIDconfig' | 'isError' | 'errorType' | 'settingIDvalue' | 'fullSettingKey'> => {
  
    switch (settingID) {
      case "gdtOutputFolder":
        return {
          platform: "electron",
          render: true,
          default: "",
          UItitle: "GDT Output Folder",
          helpMessage: "gdt output folder",
          devDescription: "The output folder where GDT files would be written",
  
        };
      case "gdtInputFolder":
        return {
          platform: "electron",
          render: true,
          default: "",
          UItitle: "GDT Input Folder",
          helpMessage: "gdt import folder",
          devDescription: "The input folder where the application should be searching for this gdt-format file (contains datatype-specific data)",
        };
    }
  
  }
  